// © Microsoft Corporation. All rights reserved.
/**
 * Widget group div class name in the DOM
 */
export const widgetGroupClassName = "peregrine-widgetgroup";
/**
 * Widgets div class name in the DOM
 */
export const widgetClassName = "peregrine-widgets";
/**
 * Widget settings div
 */
export const widgetSettingsClassName = "peregrine-widget-settings";
/**
 * Widgets script core bundle class name in the DOM
 */
export const coreBundleClassName = "peregrine-core-bundle";
/**
 * Widget info attribute (used in both 'peregrine-widgetgroup' divs and 'peregrine-widgets' divs)
 */
export const widgetInfoAttribute = "data-widget";
/**
 * Widget data view context attribute
 */
export const widgetDataViewContext = "data-view-context";
/**
 * Widget render state attribute
 */
export const widgetRenderStateAttribute = "data-widget-state";
/**
 * Attribute name of the pcsData.info in head element
 */
export const headTagDataInfoAttribute = "data-info";
/**
  * Attribute name of the pcsData.clientSettings in head element
  */
export const headTagtClientSettingAttribute = "data-client-settings";
/**
  * Attribute name of the pcsData.canvasInfo in head element
  */
export const headTagtCanvasInfo = "data-canvas-info";
/**
 * App type name of sharedWidgets app
 */
export const sharedWidgetsAppTypeName = "sharedWidgets";
/**
 * App type name of MSN studio app
 */
export const msnStudioAppTypeName = "msnStudio";
/**
 * App type name of bingHomepage app
 */
export const bingHomepageAppTypeName = "bingHomepage";
/**
  * Page type of bingHomepage app (default search page)
  */
export const bingHomepagePageType = "widgetfeed";
/**
  * Page type of bingHomepage app (no search results page)
  */
export const bingNoResultsPageType = "bingNoResultsPage";
/**
  * Page name of bingHomepage app
  */
export const bingHomepagePageName = "widgetfeed";
/**
 * Ocid of bingHomepage app
 */
export const bingHomepageOcid = "BingHp01";
/**
 * Ocid of sharedWidgets app
 */
export const sharedWidgetsOcid = "hpwidget";
/**
 * Ocid of sharedWidgets app
 */
export const msnStudioOcid = "msnstudio";
/**
 * Page Product of bingHomepage app
 */
export const bingHomepageProductName = "bing";
/**
 * Widget Custom Event name
 */
export const widgetCustomEventName = "PeregrineWidgetEvent";
/**
 * App type name of distribution app
 */
export const distributionAppTypeName = "distribution";
/**
 * Page type of distribution app
 */
export const distributionPageType = "widgetfeed";
/**
 * Page name of distribution app
 */
export const distributionPageName = "widgetfeed";
/**
 * Ocid of distribution app
 */
export const distributionOcid = "distribution";
/**
 * Page Product of distribution app
 */
export const distributionProductName = "distribution";
/**
* Static Server Endpoint name
*/
export const staticServerEndpoint = "staticview.msn.com";
/**
* Static Server Endpoint name for cn domain
*/
export const staticServerEndpointCnDomain = "staticview.msn.cn";
/**
 * PCS Response cache key
 */
export const pwPcsResponseCacheKey = "pw-pcsresponse";
/**
 * Duration of time until PCS response is considered valid from cache.
 * 172800000 = 2 days in milliseconds
 * 2 days: because telemetry pipeline would throw away events with activity id older than 2 days
 */
export const pwPcsResponseCacheDuration = 172800000;
/**
 * Duration of time until PCS response is considered valid from cache for Prong 2
 * 30000 = 30 seconds in milliseconds
 * 30 seconds: because Prong 2 has several flights where a live call to PCS is needed for updating the
 * response info and cannot rely on the stale info in the cache from longer periods.
*/
export const pwPcsResponseProng2CacheDuration = 30000;
/**
 * Duration of time until PCS response is considered valid from cache for always cached app
 * 2592000000 = 30 days in milliseconds
 * for always cached app, the concept is that we always want user to load the "previous app version" from cache.
 * Then we use an app cache manager to update the cache in the background.
 * Then the cache mamanger will decide if current app version is to old and current page view need to be reloaded
 * ideally the cache duration can be set to a very long time like 1 year, which is depends on how long the history app
 * bundles are stored in the server. But for now, we set it to 30 days.
 * NOTE: to understand the SRM issue, we use a very short cache duration for now. Then plan to gradually increase it, until we see the SRM issue happens.
 */
export const alwaysCachedAppPcsResponseCacheDuration = 86400000; // 24hrs
/**
 * Loading icon class name
 */
export const widgetLoadingIconClassName = "peregrine-widget-load-icon";
/**
 * EdgeChromium expected widget cards local storage key.
 */
export const expectedWidgetsCardsLocalStorageKey = "expected-widget-cards";
export const widgetsCardsArgsKey = "widgets-cards-args";
//# sourceMappingURL=Widgets.js.map